import { render, staticRenderFns } from "./AutocompleteSuggestions.vue?vue&type=template&id=292f352d&"
import script from "./AutocompleteSuggestions.vue?vue&type=script&lang=js&"
export * from "./AutocompleteSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports